import moment from 'moment';

export const LAST_LOGIN_ANY = 'any';

export const STATUS_ACTIVE = 'active';
export const STATUS_INVITED = 'invited';
export const STATUS_INVITE_EXPIRED = 'invite_expired';

export const formatActivityDate = (value) => moment(value).format('DD MMM YYYY');

export const formatActivityDateTime = (value) => moment(value).format('DD MMM YYYY HH:mm');
